import { Component, OnInit, Input } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CookieService } from "ngx-cookie";

declare const $: any;

@Component({
  selector: "app-summernote",
  templateUrl: "./summernote.component.html",
  styleUrls: ["./summernote.component.css"],
})
export class SummernoteComponent implements OnInit {
  @Input() dataModel: any = "";
  themes: any[] = [];
  allClasses: any[] = [];
  colors: any[] = [];
  fonts: any[] = [];
  user: any;

  constructor(
    private authService: AuthService,
    private httpClient: HttpClient,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    this.getTheme();
  }
  getEditorSettings() {
    this.user = this.authService.getLoggedUser();
    var siteId = this.user.siteId;
    var UserId = this.user.id;
    var token = "bearer " + this.cookieService.get("admin_access_token");

    var api = window.location.origin + "/api/";

    // var path = window['config'].apiUrl + '/';
    var classes = [];
    var colors = [
      [
        "#000000",
        "#424242",
        "#636363",
        "#9C9C94",
        "#CEC6CE",
        "#EFEFEF",
        "#F7F7F7",
        "#FFFFFF",
      ],
      [
        "#FF0000",
        "#FF9C00",
        "#FFFF00",
        "#00FF00",
        "#00FFFF",
        "#0000FF",
        "#9C00FF",
        "#FF00FF",
      ],
      [
        "#F7C6CE",
        "#FFE7CE",
        "#FFEFC6",
        "#D6EFD6",
        "#CEDEE7",
        "#CEE7F7",
        "#D6D6E7",
        "#E7D6DE",
      ],
      [
        "#E79C9C",
        "#FFC69C",
        "#FFE79C",
        "#B5D6A5",
        "#A5C6CE",
        "#9CC6EF",
        "#B5A5D6",
        "#D6A5BD",
      ],
      [
        "#E76363",
        "#F7AD6B",
        "#FFD663",
        "#94BD7B",
        "#73A5AD",
        "#6BADDE",
        "#8C7BC6",
        "#C67BA5",
      ],
      [
        "#CE0000",
        "#E79439",
        "#EFC631",
        "#6BA54A",
        "#4A7B8C",
        "#3984C6",
        "#634AA5",
        "#A54A7B",
      ],
      [
        "#9C0000",
        "#B56308",
        "#BD9400",
        "#397B21",
        "#104A5A",
        "#085294",
        "#311873",
        "#731842",
      ],
      [
        "#630000",
        "#7B3900",
        "#846300",
        "#295218",
        "#083139",
        "#003163",
        "#21104A",
        "#4A1031",
      ],
    ];
    var colorsName = [
      [
        "Black",
        "Tundora",
        "Dove Gray",
        "Star Dust",
        "Pale Slate",
        "Gallery",
        "Alabaster",
        "White",
      ],
      [
        "Red",
        "Orange Peel",
        "Yellow",
        "Green",
        "Cyan",
        "Blue",
        "Electric Violet",
        "Magenta",
      ],
      [
        "Azalea",
        "Karry",
        "Egg White",
        "Zanah",
        "Botticelli",
        "Tropical Blue",
        "Mischka",
        "Twilight",
      ],
      [
        "Tonys Pink",
        "Peach Orange",
        "Cream Brulee",
        "Sprout",
        "Casper",
        "Perano",
        "Cold Purple",
        "Careys Pink",
      ],
      [
        "Mandy",
        "Rajah",
        "Dandelion",
        "Olivine",
        "Gulf Stream",
        "Viking",
        "Blue Marguerite",
        "Puce",
      ],
      [
        "Guardsman Red",
        "Fire Bush",
        "Golden Dream",
        "Chelsea Cucumber",
        "Smalt Blue",
        "Boston Blue",
        "Butterfly Bush",
        "Cadillac",
      ],
      [
        "Sangria",
        "Mai Tai",
        "Buddha Gold",
        "Forest Green",
        "Eden",
        "Venice Blue",
        "Meteorite",
        "Claret",
      ],
      [
        "Rosewood",
        "Cinnamon",
        "Olive",
        "Parsley",
        "Tiber",
        "Midnight Blue",
        "Valentino",
        "Loulou",
      ],
    ];
    var data = this.dataModel || "";
    var fonts = ["Arial", "Arial Black", "Comic Sans MS", "Courier New"];
    if (this.fonts.length) {
      this.fonts.forEach((element) => {
        fonts.push(element.name);
      });
    }
    if (this.allClasses.length) {
      this.allClasses.forEach((element) => {
        classes.push(element);
      });
    }
    var newColors = [];
    var newColorsName = [];
    if (this.colors.length) {
      this.colors.forEach((element) => {
        newColors.push(element.value);
        newColorsName.push(element.name);
      });
      colors.push(newColors);
      colorsName.push(newColorsName);
    }

    $(document).ready(function () {
      $.extend($.summernote.plugins, {
        /**
         * @param {Object} context - context object has status of editor.
         */
        addclass: function (context) {
          var self = this;
          if (typeof context.options.addclass === "undefined") {
            context.options.addclass = {};
          }
          if (typeof context.options.addclass.classTags === "undefined") {
            context.options.addclass.classTags = [
              "jumbotron",
              "lead",
              "img-rounded",
              "img-circle",
              "img-responsive",
              "btn",
              "btn btn-success",
              "btn btn-danger",
              "text-muted",
              "text-primary",
              "text-warning",
              "text-danger",
              "text-success",
              "table-bordered",
              "table-responsive",
              "alert",
              "alert alert-success",
              "alert alert-info",
              "alert alert-warning",
              "alert alert-danger",
              "visible-sm",
              "hidden-xs",
              "hidden-md",
              "hidden-lg",
              "hidden-print",
            ];
            //  console.log("Please define your summernote.options.addclass.classTags array");
          }
          // ui has renders to build ui elements.
          //  - you can create a button with `ui.button`
          var ui = $.summernote.ui;

          addStyleString(
            ".scrollable-menu {height: auto; max-height: 200px; max-width:300px; overflow-x: hidden;}"
          );

          context.memo("button.addclass", function () {
            return ui
              .buttonGroup([
                ui.button({
                  className: "dropdown-toggle",
                  contents:
                    '<i class="fab fa-css3-alt"/>' +
                    " " +
                    ui.icon(context.options.icons.caret, "span"),
                  //ui.icon(context.options.icons.magic) + ' ' + ui.icon(context.options.icons.caret, 'span'),
                  tooltip: "Graphic profile classes", //lang.style.style,
                  data: {
                    toggle: "dropdown",
                  },
                }),
                ui.dropdown({
                  className: "dropdown-style scrollable-menu",
                  items: context.options.addclass.classTags,
                  template: function (item) {
                    if (typeof item === "string") {
                      item = { tag: "div", title: item, value: item };
                    }

                    var tag = item.tag;
                    var title = item.title;
                    var style = item.style
                      ? ' style="' + item.style + '" '
                      : "";
                    var cssclass = item.value
                      ? ' class="' + item.value + '" '
                      : "";

                    return (
                      "<" +
                      tag +
                      " " +
                      style +
                      cssclass +
                      ">" +
                      title +
                      "</" +
                      tag +
                      ">"
                    );
                  },
                  click: function (event, namespace, value) {
                    event.preventDefault();
                    value =
                      value ||
                      $(event.target).closest("[data-value]").data("value");

                    var $node = $(context.invoke("restoreTarget"));
                    if ($node.length == 0) {
                      $node = $(
                        document.getSelection().focusNode.parentElement,
                        ".note-editable"
                      );
                    }

                    if (
                      typeof context.options.addclass !== "undefined" &&
                      typeof context.options.addclass.debug !== "undefined" &&
                      context.options.addclass.debug
                    ) {
                      console.debug(
                        context.invoke("restoreTarget"),
                        $node,
                        "toggling class: " + value,
                        window.getSelection()
                      );
                    }

                    $node.toggleClass(value);
                  },
                }),
              ])
              .render();
            // return $optionList;
          });

          function addStyleString(str) {
            var node = document.createElement("style");
            node.innerHTML = str;
            document.body.appendChild(node);
          }

          // This events will be attached when editor is initialized.
          this.events = {
            // This will be called after modules are initialized.
            "summernote.init": function (we, e) {
              //console.log('summernote initialized', we, e);
            },
            // This will be called when user releases a key on editable.
            "summernote.keyup": function (we, e) {
              //  console.log('summernote keyup', we, e);
            },
          };

          // This method will be called when editor is initialized by $('..').summernote();
          // You can create elements for plugin
          this.initialize = function () {};

          // This methods will be called when editor is destroyed by $('..').summernote('destroy');
          // You should remove elements on `initialize`.
          this.destroy = function () {
            /*  this.$panel.remove();
             this.$panel = null; */
          };
        },
      });
      $(".summernote").summernote({
        height: 400,
        fontNames: fonts,
        fontNamesIgnoreCheck: fonts,
        styleTags: [
          "p",
          {
            title: "Blockquote",
            tag: "blockquote",
            className: "blockquote",
            value: "blockquote",
          },
          "pre",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
        ],
        addclass: {
          debug: false,
          classTags: classes,
        },
        colors: colors,
        colorsName: colorsName,
        toolbar: [
          // [groupName, [list of button]]
          ["style", ["style", "addclass", "clear"]],
          ["img", ["picture"]],
          ["fontname", ["fontname"]],
          ["fontstyle", ["bold", "italic", "ul", "ol", "link", "paragraph"]],
          [
            "fontstyleextra",
            [
              "strikethrough",
              "underline",
              "hr",
              "color",
              "superscript",
              "subscript",
            ],
          ],
          ["extra", ["video", "table", "height"]],
          ["misc", ["undo", "redo", "codeview", "help"]],
        ],
        callbacks: {
          onImageUpload: function (image) {
            var data = new FormData();
            data.append("path", "");
            data.append("file", image[0]);
            data.append("Force","true");
            $.ajax({
              url: api + "Media/upload",
              headers: {
                SiteId: siteId + "",
                UserId: UserId,
                FromEditor: true,
                Authorization: token,
              },
              cache: false,
              contentType: false,
              processData: false,
              data: data,
              type: "POST",
              success: function (fullPath) {
                // while (fullPath.indexOf("\\") !== -1) {
                //   fullPath = fullPath.replace("\\", "/");
                // }
                fullPath = "/" + fullPath.content.uploaded[0].publicUrl;
                var image = $("<img>")
                  .attr("src", fullPath)
                  .addClass("img-fluid");
                $(".summernote").summernote("insertNode", image[0]);
              },
              error: function (data) {
                console.log(data);
              },
            });
          },
          onMediaDelete: function (image) {
            $.ajax({
              url: api + "Media/DeleteFile",
              headers: { SiteId: siteId + "", UserId: UserId + "" },
              dataType: "json",
              contentType: "application/json",
              data: JSON.stringify({
                Path: image[0].src.split("DCMS-backend/").pop(),
              }),
              type: "POST",
              success: function (fullPath) {},
              error: function (data) {},
            });
          },
        },
      });
    });
  }

  getTheme() {
    this.httpClient.get("/Themes/GetThemes").subscribe((res: any) => {
      for (let i = 0; i < res.length; i++) {
        const element = res[i];
        if (element.isActive == 1) {
          this.allClasses = element.classes ? JSON.parse(element.classes) : [];
          this.colors = element.colors ? JSON.parse(element.colors) : [];
          this.fonts = element.fonts ? JSON.parse(element.fonts) : [];
          this.setSiteTheme(element);
        }
      }
      this.getEditorSettings();
    });
  }

  setSiteTheme(res) {
    const head = document.getElementsByTagName("head")[0];
    var oldFonts = document.getElementsByTagName("style");
    var oldFontsLinks = document.getElementsByTagName("link");

    for (let index = 0; index < oldFonts.length; index++) {
      const element = oldFonts[index];
      if (element.id.indexOf("theme-font") != -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }

    for (let index = 0; index < oldFontsLinks.length; index++) {
      const element = oldFontsLinks[index];
      var getName = element.getAttribute("name");
      if (getName && getName.indexOf("theme-font") != -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }
    if (res.fonts) {
      var fonts = JSON.parse(res.fonts);
      for (let i = 0; i < fonts.length; i++) {
        const f = fonts[i];
        if (f.link.includes("<link")) {
          $("head").append(f.link);
        } else {
          if (f.link.includes("/Resources")) {
            const style = document.createElement("style");
            style.type = "text/css";
            style.id = "theme-font";
            var css =
              `
            @font-face {
            font-family: ` +
              f.name +
              `;
            src: url(` +
              f.link +
              `);
          }
          `;

            style.appendChild(document.createTextNode(css));
            head.appendChild(style);
          } else {
            var font = document.createElement("link");
            font.setAttribute("rel", "stylesheet");
            font.setAttribute("type", "text/css");
            font.setAttribute("name", "theme-font");
            font.setAttribute("href", f.link);
            if (!f.link.includes(".css")) {
              document.head.appendChild(font);
            }
          }
        }

        // if (f.IsPrimary) {
        //   document.body.style.fontFamily = f.name;
        // }
      }
    }
  }
}
